import React from 'react';

const SvgComponent = (props) => (
  <svg viewBox="0 0 18 18" width="1em" height="1em" {...props}>
    <path d="M15 14H4.361l.808-2h9.395L18 3.5H2.294L1.283 1H0v.026l4.156 10.281L3.067 14H2.5a1.5 1.5 0 1 0 1.47 1.2h9.561A1.5 1.5 0 1 0 15 14z" />
  </svg>
);

export default SvgComponent;
